<script>
export default {
  components: {},
  props: {
    day: {
      type: Object,
      required: true,
      default: () => {},
    },
    mealtime: {
      type: Object,
      required: true,
      default: () => {},
    },
    slotHasDishes: {
      type: Boolean,
      required: true,
    },
  },
  data() {
    return {};
  },
  computed: {},
  mounted() {},
  methods: {
    activateCopy() {
      this.$emit('activate-copy');
    },
    removeMeal() {
      this.$emit('remove-meal');
    },
  },
};
</script>

<template>
  <ul>
    <li @click="activateCopy">
      <svg width="22" height="26" viewBox="0 0 22 26" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M15.876.4H2.296C1.053.4.034 1.43.034 2.69v16.037h2.264V2.691h13.579V.4zm3.394 4.582H6.823c-1.245 0-2.263 1.03-2.263 2.29V23.31c0 1.26 1.018 2.291 2.263 2.291H19.27c1.245 0 2.264-1.03 2.264-2.29V7.272c0-1.26-1.019-2.291-2.264-2.291zM6.823 23.309H19.27V7.273H6.823v16.036z" fill="#2F70DE"/></svg>
      <span>Copy Meal</span>
    </li>
    <li @click="removeMeal" v-if="slotHasDishes">
      <svg width="14" height="18" viewBox="0 0 14 18" fill="none" xmlns="http://www.w3.org/2000/svg" v-bind:class="'icon'" v-bind:svg-inline="''" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill-rule="evenodd" clip-rule="evenodd" d="M10.5 1H14v2H0V1h3.5l1-1h5l1 1zM3 18c-1.1 0-2-.9-2-2V4h12v12c0 1.1-.9 2-2 2H3z" fill="#000"/></svg>
      <span>Remove Meal</span>
    </li>
  </ul>
</template>

<style lang="scss" scoped>
@import '@design';
// stylelint-disable selector-pseudo-element-no-unknown
// stylelint-disable selector-max-type

ul {
  @include calc-font-size(0.7);

  padding-bottom: 1rem;
  width: 100%;
}

.divider-horizontal {
  align-self: center;
  border-top: 1px solid white;
  height: 0.5rem;
  margin-left: auto;
  margin-right: auto;
  margin-top: 1rem;
  opacity: 0.2;
  width: 80%;
}

.icon {
  height: 1.5rem;
  margin-right: 0.8rem;
  width: 1.8rem;

  path {
    fill: black;
  }
}

li {
  cursor: pointer;
  padding: 0.4rem 1rem;

  &.disabled {
    opacity: 0.5;
    pointer-events: none;
  }

  &:hover {
    background-color: $color-heading-text;

    .icon {
      path {
        fill: $color-tooltip-calendar-bg;
      }
    }
  }

  &:first-child {
    padding-top: 1rem;

    &:hover {
      background-color: $color-heading-text;
      border-top-left-radius: $base-border-radius-md;
      border-top-right-radius: $base-border-radius-md;
    }
  }

  span {
    @include calc-font-size(0.7);

    font-weight: 800;
    letter-spacing: 0.116667px;
  }
}
</style>
